import { OutBoundConstants } from '../Constants';
import { adminUsersServices } from '../Services';

export const outboundActions = {
    searchOutBound
};

function searchOutBound(data: any) {
    return (dispatch:any) => {
        dispatch(dispatchFunction({
            type: OutBoundConstants.SEARCH_OUTBOUND_REQUEST,
            data: null
        }));
        adminUsersServices.searchOutBound(data)
            .then(
                response => {
                    if (response.status) {
                        dispatch(dispatchFunction({
                            type: OutBoundConstants.SEARCH_OUTBOUND_SUCCESS,
                            data: response.data
                        }));
                    } else {
                        dispatch(dispatchFunction({
                            type: OutBoundConstants.SEARCH_OUTBOUND_FAILURE,
                            data: response
                        }));
                    }
                },
                error => {
                    dispatch(dispatchFunction({
                        type: OutBoundConstants.SEARCH_OUTBOUND_FAILURE,
                        data: error.message
                    }));
                }
            );
    };
}

function dispatchFunction(data: any) {
    // To do: check for refresh / unauthorized error
    return {
        type: data.type,
        data: data.data
    };
}